import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {RouterModule} from '@angular/router';
import {FaIconModule} from '@app/core/modules/fa-icon.module';
import {FlexLayoutModule} from '@angular/flex-layout';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MatLegacyButtonModule as MatButtonModule} from '@angular/material/legacy-button';
import {MatLegacyCheckboxModule as MatCheckboxModule} from '@angular/material/legacy-checkbox';
import {MatLegacyFormFieldModule as MatFormFieldModule} from '@angular/material/legacy-form-field';
import {MatIconModule} from '@angular/material/icon';
import {MatLegacyInputModule as MatInputModule} from '@angular/material/legacy-input';
import {MatLegacyProgressBarModule as MatProgressBarModule} from '@angular/material/legacy-progress-bar';
import {MatToolbarModule} from '@angular/material/toolbar';
import {MatLegacyTooltipModule as MatTooltipModule} from '@angular/material/legacy-tooltip';
import {Ng9PasswordStrengthBarModule} from 'ng9-password-strength-bar';
import {DirectivesModule} from '@app/core/directives/directives.module';
import {ClipboardModule} from 'ngx-clipboard';
import {MatLegacyCardModule as MatCardModule} from '@angular/material/legacy-card';
import {MatLegacyDialogModule as MatDialogModule} from '@angular/material/legacy-dialog';
import {MatExpansionModule} from '@angular/material/expansion';
import {MatLegacyListModule as MatListModule} from '@angular/material/legacy-list';
import {MatLegacyMenuModule as MatMenuModule} from '@angular/material/legacy-menu';
import {MatSidenavModule} from '@angular/material/sidenav';
import {MatLegacySnackBarModule as MatSnackBarModule} from '@angular/material/legacy-snack-bar';
import {UserSecuritySettingsComponent} from '@app/views/common/user-security-settings/user-security-settings';
import {FooterPageComponent} from '@app/core/comp/footer-page/footer-page.component';
import {PasswordComponent} from '@app/core/comp/password/password.component';
import {NgcPrivacyPolicyComponent} from '@app/views/common/privacy-policy/privacy-policy.component';
import {AnnouncementContentViewerComponent} from '@app/core/comp/dialog/ann-content-viewer/ann-content-viewer.component';
import {ConfirmDialogComponent} from '@app/core/comp/dialog/confirm-dialog/confirm-dialog.component';
import {DataErrorComponent} from '@app/core/comp/spot-label/data-error/data-error.component';
import {HelpComponent} from '@app/core/comp/help/help.component';
import {PipesModule} from '@app/core/pipes/pipes.module';
import {MatLegacyProgressSpinnerModule as MatProgressSpinnerModule} from '@angular/material/legacy-progress-spinner';
import {VerifyPhoneDialogComponent} from '@app/core/comp/dialog/verify-phone-dialog/verify-phone-dialog.component';
import {VerifyPhoneComponent} from '@app/core/comp/dialog/verify-phone-dialog/verify-phone/verify-phone.component';
import {RecoveryCodesComponent} from '@app/core/comp/dialog/verify-phone-dialog/recovery-codes/recovery-codes.component';
import {VerifyPasswordComponent} from '@app/core/comp/dialog/verify-phone-dialog/verify-password/verify-password.component';
import {InputFieldDialogComponent} from '@app/core/comp/dialog/input-field-dialog/input-field-dialog.component';
import {PIIShieldConfirmDialogComponent} from '@app/core/comp/dialog/piishield-confirm-dialog/piishield-confirm-dialog.component';
import {PIIShieldAttributesListComponent} from '@app/core/comp/dialog/piishield-confirm-dialog/piishield-attributes-list/piishield-attributes-list.component';
import {ETXLoginErrorDialogComponent} from '@app/views/databrowsing/entity-details-view/components/etx-login-error-dialog/etx-login-error-dialog.component';
import {FormulaDialogComponent} from '@app/core/comp/dialog/formula-dialog/formula-dialog.component';
import {MatLegacySelectModule as MatSelectModule} from '@angular/material/legacy-select';
import {CdkTreeModule} from '@angular/cdk/tree';
import {MatTreeModule} from '@angular/material/tree';
import {MatLegacyAutocompleteModule as MatAutocompleteModule} from '@angular/material/legacy-autocomplete';
import {SchoolYearRolloverSettingsDialogComponent} from '@app/core/comp/dialog/school-year-rollover-settings-dialog/school-year-rollover-settings-dialog.component';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatLegacySlideToggleModule as MatSlideToggleModule} from '@angular/material/legacy-slide-toggle';
import {DataRolloverSettingsComponent} from '@app/views/common/school-year-rollover/data-rollover-setting/data-rollover-settings.component';
import {UserAuditComponent} from '@app/core/comp/user-audit/user-audit.component';
import {MatLegacyTableModule as MatTableModule} from '@angular/material/legacy-table';
import {MatLegacyPaginatorModule as MatPaginatorModule} from '@angular/material/legacy-paginator';
import {SlickIdComponent} from '@app/views/databrowsing/entity-details-view/components/slick-id/slick-id.component';
import {GhostTableComponent} from '@app/core/comp/ghost-components/ghost-table/ghost-table.component';
import {MatSortModule} from '@angular/material/sort';
import {InfiniteScrollModule} from 'ngx-infinite-scroll';
import {NotificationDialogComponent} from '@app/core/comp/dialog/notification-dialog/notification-dialog.component';
import {TotpMfaSetupDialogComponent} from '@app/core/comp/dialog/totp-mfa-setup-dialog/totp-mfa-setup-dialog.component';
import {TotpMfaSetupComponent} from '@app/core/comp/dialog/totp-mfa-setup-dialog/totp-mfa-setup/totp-mfa-setup.component';
import {QRCodeModule} from 'angularx-qrcode';
import {InputPhoneComponent} from '@app/core/comp/dialog/verify-phone-dialog/input-phone/input-phone.component';
import {ChangePasswordDialogComponent} from '@app/core/comp/dialog/change-password-dialog/change-password-dialog.component';
import {UserMfaSettingsComponent} from '@app/views/common/user-security-settings/user-mfa-settings/user-mfa-settings';


@NgModule({
    imports: [
        CommonModule,
        FlexLayoutModule,
        FormsModule.withConfig({
            callSetDisabledState: 'whenDisabledForLegacyCode',
        }),
        ReactiveFormsModule.withConfig({
            callSetDisabledState: 'whenDisabledForLegacyCode',
        }),
        RouterModule,
        MatProgressBarModule,
        MatProgressSpinnerModule,
        MatFormFieldModule,
        MatIconModule,
        MatToolbarModule,
        MatCheckboxModule,
        MatTooltipModule,
        MatInputModule,
        MatButtonModule,
        MatCardModule,
        MatSnackBarModule,
        MatDialogModule,
        MatExpansionModule,
        MatSidenavModule,
        MatMenuModule,
        MatListModule,
        MatSelectModule,
        MatFormFieldModule,
        CdkTreeModule,
        MatTreeModule,
        MatAutocompleteModule,
        MatDatepickerModule,
        MatSlideToggleModule,
        MatTableModule,
        MatPaginatorModule,
        MatSortModule,
        FaIconModule,
        Ng9PasswordStrengthBarModule,
        InfiniteScrollModule,
        DirectivesModule,
        ClipboardModule,
        PipesModule,
        QRCodeModule
    ],
    declarations: [
        FooterPageComponent,
        DataErrorComponent,
        HelpComponent,
        NgcPrivacyPolicyComponent,
        ConfirmDialogComponent,
        AnnouncementContentViewerComponent,
        NotificationDialogComponent,
        UserSecuritySettingsComponent,
        UserMfaSettingsComponent,
        PasswordComponent,
        VerifyPhoneDialogComponent,
        VerifyPhoneComponent,
        RecoveryCodesComponent,
        VerifyPasswordComponent,
        InputFieldDialogComponent,
        PIIShieldConfirmDialogComponent,
        PIIShieldAttributesListComponent,
        ETXLoginErrorDialogComponent,
        FormulaDialogComponent,
        SchoolYearRolloverSettingsDialogComponent,
        DataRolloverSettingsComponent,
        UserAuditComponent,
        SlickIdComponent,
        GhostTableComponent,
        TotpMfaSetupDialogComponent,
        TotpMfaSetupComponent,
        InputPhoneComponent,
        ChangePasswordDialogComponent
    ],
    exports: [
        MatProgressBarModule,
        MatProgressSpinnerModule,
        MatFormFieldModule,
        MatIconModule,
        MatToolbarModule,
        MatCheckboxModule,
        MatTooltipModule,
        MatInputModule,
        MatButtonModule,
        MatCardModule,
        MatSnackBarModule,
        MatDialogModule,
        MatExpansionModule,
        MatSidenavModule,
        MatMenuModule,
        MatListModule,
        MatSelectModule,
        MatFormFieldModule,
        CdkTreeModule,
        MatTreeModule,
        MatAutocompleteModule,
        MatDatepickerModule,
        MatSlideToggleModule,
        MatTableModule,
        MatPaginatorModule,
        MatSortModule,
        FaIconModule,
        Ng9PasswordStrengthBarModule,
        DirectivesModule,
        ClipboardModule,
        CommonModule,
        FlexLayoutModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule,
        InfiniteScrollModule,
        PipesModule,
        FooterPageComponent,
        DataErrorComponent,
        HelpComponent,
        NgcPrivacyPolicyComponent,
        AnnouncementContentViewerComponent,
        NotificationDialogComponent,
        UserSecuritySettingsComponent,
        UserMfaSettingsComponent,
        PasswordComponent,
        VerifyPhoneDialogComponent,
        VerifyPhoneComponent,
        RecoveryCodesComponent,
        VerifyPasswordComponent,
        InputFieldDialogComponent,
        PIIShieldAttributesListComponent,
        DataRolloverSettingsComponent,
        UserAuditComponent,
        SlickIdComponent,
        GhostTableComponent,
        ETXLoginErrorDialogComponent,
        TotpMfaSetupDialogComponent,
        TotpMfaSetupComponent,
        InputPhoneComponent,
        ChangePasswordDialogComponent
    ]
})
export class SharedMainModule { }
